import { Reply } from "@libs/zapi-ui/ds/components/reply";
import { Stagger } from "@libs/zapi-ui/ds/components/stagger";
import { TextReveal } from "@libs/zapi-ui/ds/components/text-reveal";
import { staggerStep } from "@libs/zapi-ui/lib/motion";

type TLeoWelcomeProps = {
  title: string;
  subtitle: string;
  suggestions: string[];
  onPick: (suggestion: string) => void;
  disabled?: boolean;
};

export function LeoWelcome({ title, subtitle, suggestions, onPick, disabled }: TLeoWelcomeProps) {
  return (
    <div data-testid="leo-welcome" className="flex min-h-full flex-1 flex-col gap-5">
      <div className="flex flex-1 flex-col items-center justify-center gap-1.5 text-center">
        <TextReveal as="h2" className="typo-h5 text-foreground" delay={120}>
          {title}
        </TextReveal>
        <p className="typo-body-sm text-muted-foreground">{subtitle}</p>
      </div>
      {suggestions.length > 0 && (
        <Stagger delay={420} step={staggerStep.base} className="flex flex-col items-start gap-1.5">
          {suggestions.map((suggestion) => (
            <Reply key={suggestion} disabled={disabled} onClick={() => onPick(suggestion)}>
              <span className="typo-body-sm">{suggestion}</span>
            </Reply>
          ))}
        </Stagger>
      )}
    </div>
  );
}
